import { render, staticRenderFns } from "./InformativeViewPage.vue?vue&type=template&id=efdc0424&scoped=true"
import script from "./InformativeViewPage.vue?vue&type=script&lang=js"
export * from "./InformativeViewPage.vue?vue&type=script&lang=js"
import style0 from "./InformativeViewPage.vue?vue&type=style&index=0&id=efdc0424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdc0424",
  null
  
)

export default component.exports